module.exports = __webpack_public_path__ + "static/media/IMG_0607.c1833b81.JPG";